import React from 'react'
// needs to import switch route redirect to naviagate from / to /search, /news, /images and so on

import { Routes, Route, Navigate } from 'react-router-dom';
import { Results } from './Results';
export const Feeds = () => {
    return (
        <div className="p-4">
        {/* Switch can render only 1 route at a time */}


            {/* <Navigate from='/' to= '/search'/> */}
            
            <Routes> 
           
        {/* Routes is replacement for Switch. Swucth can route only 1 route, but routes is capable of many*/}
                {/* <Route path={['/search','/images','/news','/videos']}> element={<Results/>}
                </Route> */}
                <Route path="/" element={<Navigate to ="/search" />}/>
                <Route exact path="/search" element={<Results/>}/>
                <Route exact path="/images" element={<Results/>}/>
                <Route exact path="/news" element={<Results/>}/>
                <Route exact path="/videos" element={<Results/>}/>
            </Routes>
        </div>
    )
}

 